//#region imports

// React
import React, { useEffect } from 'react';

// Tippy.js
import tippy, { delegate } from 'tippy.js';
import 'tippy.js/dist/tippy.css'; 
import 'tippy.js/animations/scale.css';

//#endregion

export default function TippyGlobal({ selectors = ['[data-tippy-content]'] }) {
    useEffect(() => {
        const instance = delegate(document.body, {
            target: selectors.join(','),
            content: (ref) => ref.getAttribute('data-tippy-content') || '',
            onShow(inst) {
                inst.setContent(inst.reference.getAttribute('data-tippy-content') || '');
            },
            // trigger: 'mouseenter',
            placement: 'top',
            arrow: true,
            duration: [0, 500],
            theme: 'dark',
            animation: 'scale',
            allowHTML: false,
        });

        return () => instance.destroy();
    }, [selectors]);

    return null;
}
